module.exports = __webpack_public_path__ + "static/img/bo.7f850859.png";